import React from'react'
import {Table as RTable} from 'reactstrap'
function Table(props) {
    return(
        <RTable hover bordered striped responsive size={props.size}>
            {props.children}
        </RTable>
    )
}
export default Table;